var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n  Made with\n  "),_c('span',{staticClass:"heart"},[_vm._v("\n    ❤\n  ")]),_vm._v("\n  by "),_c('a',{attrs:{"className":"{css(styles.footerLink)}","href":"http://geogaming.io","target":"_blank"}},[_vm._v("Geogaming.io")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38bb801e","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/Heart.vue
// module id = 968
// module chunks = 1